import { FaCommentDots } from "react-icons/fa";

export const SUPER_ADMIN_FEEDBACK_MANAGEMENT_ITEMS = [
  {
    id: "sa_feedback_all",
    label: "All Feedback",
    to: "/super-admin/feedback",
    icon: FaCommentDots,
    end: true,
    activePathPrefix: "/super-admin/feedback",
  },
];

export const SUPER_ADMIN_FEEDBACK_MANAGEMENT_GROUP = {
  id: "feedback_management",
  heading: "Feedback Management",
  icon: FaCommentDots,
  items: SUPER_ADMIN_FEEDBACK_MANAGEMENT_ITEMS,
};
